<template>
  <div class="row">
    <div class="col-sm-4 col-sm-offset-4">
      <p class="text-center text-primary"> <span class="text-danger">* </span> No use espacios en blanco ni caracteres como la <b>ñ</b> </p>
      <div class="form-group" :class="{'has-error': validation.hasError('datos.login')}">
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> <span class="text-danger">*</span> Usuario:</div>
           <input type="text" v-model.trim="datos.login" class="form-control" placeholder="Usuario de acceso">
        </div>
        <div class="error" v-if="validation.hasError('datos.login')"> {{validation.firstError('datos.login')}} </div>
      </div>

      <div class="form-group" :class="{'has-error': validation.hasError('datos.clave')}">
        <div class="input-group input-group-sm">
          <div class="input-group-addon"> <span class="text-danger">*</span> Clave Nueva:</div>
           <input type="text" v-model.trim="datos.clave" class="form-control" placeholder="Ingrese la nueva clave">
        </div>
        <div class="error" v-if="validation.hasError('datos.clave')"> {{validation.firstError('datos.clave')}} </div>
      </div>

      <Alertas ref="alertar" />
      <button class="btn btn-sm btn-azul center-block" @click="actualizar()" :disabled="$store.state.cambiarDatosAcceso==false"> Actualizar datos </button>
    </div>

    <notifications group="auth" position="bottom right" />    
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import Alertas from '@/components/AAlertas.vue';
import {parseJsonError} from '@/components/Utils.js'
import {getUserData} from '@/accessToken.js'
import gql from 'graphql-tag';
export default {
  data(){
    return{
      datos:{
        id: -1,
        login: null,
        clave: null,
      }
    }
  },
  components:{Alertas},
  validators: {
    'datos.login'(value){ return Validator.value(value).minLength(5).required(); },
    'datos.clave'(value){ return Validator.value(value).minLength(5).required(); },
  },
  methods:{
    actualizar(){
      const ex = getUserData(); 
      if( ex ){ 
        const userdata = this.$store.state.DATA_USER;
        if( (this.datos.clave+'').startsWith(userdata.num_doc) ){
          this.$refs.alertar.invalido( "No puede usar su documento como subcadena inicial de la nueva clave." ); 
          return;
        }
      }
      this.$validate().then((success) => {
        var obj = window.Object.assign( {},this.datos );
        if (success) {
          // estas acciones van en par, set el objeto para luego limpiar campos nulos
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');

          this.$refs.alertar.cargando();
          this.enviarDatos( obj );
        }else{
          this.$refs.alertar.invalido( "Revise los datos" );
        }
      });
    },
    async enviarDatos( obj ){
      var vue = this;
      var sql = gql`mutation{ cambiarDatosAcceso(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      window.console.log( sql )

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
        if(data.data.cambiarDatosAcceso.ok){
          vue.$refs.alertar.success();
          
        }else{
          var errores = JSON.stringify(data.data.cambiarDatosAcceso.errors);
          var obj = JSON.parse( errores );
          var vals = '';
          obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
          vue.$refs.alertar.invalido( vals );
        }
        window.console.log(data);
      }).catch((error) => {
        vue.$refs.alertar.invalido();
        window.console.error(window.stringifyObject(error));
        this.$notify( parseJsonError( error,'cambiarDatosAcceso' ) )
      })
    }
  },
  mounted(){
    window.console.log( "fhfghfgh   ",this.datos ) 
   var u = window.sessionStorage.xxusuario;
   if( u ){
     var xu = JSON.parse( u );
     if( xu ) {
       this.datos.id = xu.id;
       this.datos.login = xu.login;
       this.datos.clave = xu.datos_personales.num_doc;
       this.datos.clave += xu.datos_personales.departamento.extension;

     }
     window.console.log( "fhfghfgh   ",this.datos,xu ) 
   }
  }
}
</script>